import { mapGetters, mapActions } from "vuex";
import account from "../../api/account";
// import menus from '../../util/menus'
import jofphMenus from "../../util/jofphMenus";
import ChangePwd from "./changePwd.dialog";
import md5 from "js-md5";
import user from "../../api/user";
// import http from '../../api/http'

// const rootSubmenuKeys = ['/workbench', '/tools', '/wos', '/setting', '/journal', '/mail']
const rootSubmenuKeys = [
  "/jofph/journal",
  "/jofph/news",
  "/jofph/workbench",
  "/jofph/special",
  "/jofph/editor",
  "/jofph/news",
  "/tools",
];
// const SVrootSubmenuKeys = ['/jofph/journal', '/jofph/news', '/jofph/workbench', '/jofph/special', '/jofph/editor', '/jofph/news']
export default {
  components: {
    ChangePwd,
  },
  data() {
    return {
      collapsed: false,
      isModalVisible: false,
      rootSubmenuKeys,
      openKeys: [""],
      active: "",
      menus: jofphMenus,
      mainNavList: [
        {
          //   name: 'IMR',
          //   path: 'imr',
          //   img: 'http://static.imrpress.tech/IMR.svg'
          // }, {
          name: "JOFPH",
          path: "jofph",
          img: "http://static.imrpress.tech/JOFPH.svg",
        },
      ],
      choMenus: "jofph",
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
  },
  mounted() {
    // this.getUserInfo()
    // const hash = md5(loginPass);

    // this.updateUser(JSON.parse(localStorage.getItem('user')))

    const sub = this.$route.path.split("/");

    const active = "/" + this.$route.path.split("/")[1];
    if (active === "/journal") {
      this.active = "/journal";
      this.onOpenChange(["/" + sub[1]]);
    } else if (active === "/jofph") {
      this.menus = jofphMenus;
      // this.rootSubmenuKeys = SVrootSubmenuKeys
      this.choMenus = "jofph";
      this.active = this.$route.path;
      this.onOpenChange(["/" + sub[1] + "/" + sub[2]]);
    } else {
      this.active = this.$route.path;
      this.onOpenChange(["/" + sub[1]]);
    }
    // if (this.user && this.user.init) {
    //   this.$message.warn('您的密码仍是初始密码，请及时修改！', 3);
    //   this.isModalVisible = true
    // }
  },
  methods: {
    ...mapActions(["updateUser", "updateLoading"]),
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(
        (key) => this.openKeys.indexOf(key) === -1
      );
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },
    onMenuClick(item) {
      this.active = item.key;
    },
    changePwd() {
      this.isModalVisible = true;
    },
    logout() {
      localStorage.removeItem("token");
      this.$router.push("/access/login");
    },
    changeTheme() {
      // window.less.modifyVars({
      //   "@primary-color": primaryColor,
      //   "@layout-header-background": '#dd0000',
      //   '@menu-dark-submenu-bg': '#dd0000',
      // });
    },
    handleCancel() {
      this.isModalVisible = false;
    },
    handleCreate() {
      const form = this.$refs.collectionForm.form;
      form.validateFields((err, values) => {
        if (err) {
          return;
        }
        const { passwordOld, passwordLogin, ensurePassword } = values;
        if (passwordLogin !== ensurePassword) {
          this.$message.success("两次密码不相同，请重新输入", 3);
          return;
        }
        account
          .changePwd({
            pwd: md5(passwordOld),
            newPwd: md5(passwordLogin),
          })
          .then((res) => {
            if (res) {
              form.resetFields();
              this.$message.error("修改成功,请重新登陆", 3);
              this.isModalVisible = false;
              setTimeout(() => {
                localStorage.removeItem("token");
                this.$router.push("/access/login");
              }, 2000);
            }
          });
      });
    },
    getUserInfo() {
      user.getUserInfo().then((res) => {
        if (res) {
          localStorage.setItem("user", JSON.stringify(res));
          this.updateUser(res);
        }
      });
    },
    // changeMainNavList (path) {
    //   this.choMenus = path
    //   switch (path) {
    //     case 'imr':
    //       this.menus = menus
    //       this.rootSubmenuKeys = rootSubmenuKeys
    //       this.active = '/workbench'
    //       this.$router.push('/workbench')
    //       break
    //     case 'jofph':
    //       this.menus = jofphMenus
    //       this.rootSubmenuKeys = SVrootSubmenuKeys
    //       this.active = '/jofph/workbench'
    //       this.$router.push('/jofph/workbench')
    //       break
    //     default:
    //       break
    //   }
    // }
  },
};
